import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenService } from './services/token.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router
    ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (TokenService.tokenGetter()) {
      return true;
    }

    this.router.navigate(['login']);
    return false;
  }
}